export default "__VITE_ASSET__CP8UQo5S__"